var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"rk-table__caret",style:({ 'margin-left': '3px' })},[_c('i',{class:[_vm.orderStatus === 'asc' ? 'up-active' : 'up']}),_c('i',{class:[_vm.orderStatus === 'desc' ? 'down-active' : 'down']})])
}
var staticRenderFns = []

export { render, staticRenderFns }